export function initTabsets() {
  const tabsets = document.querySelectorAll('[data-tabset]');

  for (const tabset of tabsets) {
    initTabset(tabset);
  }
}

export function initTabset(tabset) {
  const tabs = tabset.querySelectorAll('[role="tab"]');

  for (const tab of tabs) {
    tab.addEventListener('click', () => {
      openTab(tab, tabset);
    });

    tab.addEventListener('keydown', (e) => {
      // on left arrow
      if (e.keyCode === 37) {
        e.preventDefault();
        openPrevTab(e.target, tabs, tabset);
        // on right arrow
      } else if (e.keyCode === 39) {
        e.preventDefault();
        openNextTab(e.target, tabs, tabset);
      }
    });
  }

  const { hash } = window.location;
  if (hash) {
    const initTab = tabset.querySelector(hash);
    if (initTab) {
      openTab(initTab, tabset);
    }
  }
}

function openNextTab(tab, tabs, tabset) {
  const nextTab = tabs[[...tabs].indexOf(tab) + 1] || tabs[0];
  if (nextTab) {
    nextTab.focus();
    openTab(nextTab, tabset);
  }
}

function openPrevTab(tab, tabs, tabset) {
  const prevTab = tabs[[...tabs].indexOf(tab) - 1] || tabs[tabs.length - 1];
  if (prevTab) {
    prevTab.focus();
    openTab(prevTab, tabset);
  }
}

function openTab(tab, tabset) {
  closeAllTabs(tabset);
  tab.setAttribute('aria-selected', 'true');
  const tabPanelId = tab.getAttribute('aria-controls');
  const tabPanel = document.getElementById(tabPanelId);
  tabPanel?.classList?.add('is-active');

  tabset.classList.add('transitioning');
  window.setTimeout(() => {
    tabset.classList.remove('transitioning');
  }, 500);
}

function closeAllTabs(tabset) {
  const tabs = tabset.querySelectorAll('[role="tab"]');

  for (const tab of tabs) {
    tab.removeAttribute('aria-selected');
  }

  const tabPanels = tabset.querySelectorAll('[role="tabpanel"]');

  for (const tabPanel of tabPanels) {
    tabPanel.classList.remove('is-active');
  }
}
